module.exports = __webpack_public_path__ + "public/adminIcons/siteConfig.svg?19503d57";